import { Link } from "react-router-dom";
import { Layers, Copy, TrendingUp, Award, Briefcase, Battery, Truck, GraduationCap, ArrowRight } from "lucide-react";

const CLUSTERS = [
  { icon: TrendingUp, title: "High-Efficiency Panels", desc: "PERC, HJT, TOPCon & IBC cell technologies compared by real-world efficiency", path: "/highest-efficiency-solar-panels" },
  { icon: Award, title: "Best Solar Panels", desc: "Top picks by use case — RV, camping, van life, off-grid & home backup", path: "/best-solar-panels" },
  { icon: Layers, title: "Flexible Solar Panels", desc: "Lightweight panels for curved roofs, boats & van conversions", path: "/flexible-solar-panels" },
  { icon: Copy, title: "Bifacial Solar Panels", desc: "Dual-sided panels that harvest reflected light for 10–30% more energy", path: "/bifacial-solar-panels" },
  { icon: Briefcase, title: "Portable Solar Panels", desc: "Foldable & suitcase panels for camping, hiking & travel", path: "/best-portable-solar-panels" },
  { icon: Battery, title: "Solar Panels for EcoFlow", desc: "Compatible panels for Delta, River Pro & all EcoFlow stations", path: "/solar-panel-for-ecoflow" },
  { icon: Truck, title: "Solar Panels for Van Life", desc: "Roof mounting, sizing & top picks for Sprinter, Transit & ProMaster", path: "/solar-panels-for-van-life" },
  { icon: GraduationCap, title: "Solar Basics & Education", desc: "Solar cell vs panel, mono vs poly, efficiency & sizing guides", path: "/solar-guides" },
];

export default function ClusterHub() {
  return (
    <section className="py-16 lg:py-24 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full mb-4">
            <span className="text-[11px] font-mono font-semibold text-accent-text tracking-[0.15em] uppercase">Explore by Topic</span>
          </div>
          <h2 className="font-heading font-bold text-3xl lg:text-4xl mb-3">Solar Panel Guides by Category</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Eight in-depth topic clusters covering every solar panel type, use case, and technology — from the highest efficiency cells to portable panels for camping.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CLUSTERS.map((cluster) => (
            <Link
              key={cluster.path}
              to={cluster.path}
              className="group relative bg-card border border-border rounded-2xl p-6 hover:border-accent/40 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                <cluster.icon className="w-6 h-6 text-accent-text" />
              </div>
              <h3 className="font-heading font-bold text-base mb-2 group-hover:text-accent transition-colors">{cluster.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">{cluster.desc}</p>
              <div className="flex items-center gap-1 text-xs font-mono text-accent-text">
                Explore <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}